import {inject} from 'aurelia-framework';

import {IdentityProvider} from 'devtag-aurelia-auth-plugin';

@inject(IdentityProvider)
export class AuthOnlyRouteFilterValueConverter {
  constructor(identityProvider) {
    this.identityProvider = identityProvider;
  }

  toView(routes){
    return routes.filter(route => !route.config.public
        && !route.config.nonAuthOnly
        && this.identityProvider.hasPermissionToRoute(route));
  }
}
